import {
  // -- GET (one)
  GET_PROJECT_SUCCESS,
  GET_PROJECT_FAILURE,
  // -- GET (list)
  LIST_PROJECT_SUCCESS,
  LIST_PROJECT_FAILURE,
  // -- UPDATE
  UPDATE_PROJECT_SUCCESS,
  UPDATE_PROJECT_FAILURE,
  // -- CREATE
  CREATE_PROJECT_SUCCESS,
  CREATE_PROJECT_FAILURE,
  // -- DELETE
  DELETE_PROJECT_SUCCESS,
  DELETE_PROJECT_FAILURE,
  // -- SEARCH
  SEARCH_PROJECTS,
  // -- IMPORT GLOBALS
  IMPORT_PROJECT_GLOBALS_FAILURE,
  IMPORT_PROJECT_GLOBALS_SUCCESS
} from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

let cacheItems = null

export const projects = (state = {}, action) => {
  switch (action.type) {
    // -- GET PROJECTS (list)
    case LIST_PROJECT_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projects.LIST_PROJECT_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case LIST_PROJECT_SUCCESS: {
      cacheItems = action.data || []

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projects.LIST_PROJECT_SUCCESS()', { state, action })

      return {
        ...state,
        items: cacheItems
      }
    }

    // -- GET PROJECT (one)
    case GET_PROJECT_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projects.GET_PROJECT_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_PROJECT_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projects.GET_PROJECT_SUCCESS()', { state, action })
      return {
        ...state,
        items: cacheItems,
        currentProject: action.data
      }
    }

    // -- CREATE PROJECT
    case CREATE_PROJECT_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projects.CREATE_PROJECT_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case CREATE_PROJECT_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projects.CREATE_PROJECT_SUCCESS()', {
        state,
        action,
        newItems: [...state.items].push(action.data)
      })

      return {
        ...state,
        items: newItems
      }
    }

    // -- UPDATE PROJECT
    case UPDATE_PROJECT_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projects.UPDATE_PROJECT_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case UPDATE_PROJECT_SUCCESS: {
      if (state.currentProject) {
        const _state = {
          ...state,
          ...state.data,
          currentProject: action.data
        }

        Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projects.UPDATE_PROJECT_SUCCESS()', { state, action, _state })

        return _state
      }
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projects.UPDATE_PROJECT_SUCCESS()', { state, action })
      return {
        ...state,
        items: state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)
      }
    }

    // -- SEARCH PROJECT
    case SEARCH_PROJECTS: {
      const txt = action.data || ''
      if (txt.length <= 1 && cacheItems === null && state.items) {
        cacheItems = [...state.items]
      }
      const escapeRegExp = (value) => value && value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
      const searchRegex = new RegExp(escapeRegExp(txt), 'i')
      const searchItems = (cacheItems || []).filter((row) =>
        Object.keys(row).some((field) => searchRegex.test(((row && row[field]) || '').toString()))
      )
      // Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projects.SEARCH_PROJECT()', { state, cacheItems, txt: action.data, searchItems })
      return {
        ...state,
        items: searchItems
      }
    }

    // -- DELETE PROJECT
    case DELETE_PROJECT_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projects.DELETE_PROJECT_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case DELETE_PROJECT_SUCCESS: {
      const items = state.items.filter((obj) => obj.id !== action.data.id)
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projects.DELETE_PROJECT_SUCCESS()', { state, action, items })
      return {
        ...state,
        items
      }
    }

    // -- IMPORT PROJECT GLOBALS
    case IMPORT_PROJECT_GLOBALS_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projects.IMPORT_PROJECT_GLOBALS_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case IMPORT_PROJECT_GLOBALS_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projects.IMPORT_PROJECT_GLOBALS_SUCCESS()', { state, action })
      return {
        ...state
      }
    }

    default:
      return state
  }
}
